import { Model, ModelUnion } from './base.model';

/**
 * Wrapper class for Map, as ES5 has poor support for TS and map extensions
 */
export class ModelMap {
    /**
     * Holds data
     * @var {Map<string, Model>}
     */
    private map = new Map<string, ModelUnion>();

    /**
     * Set a key to value
     * @param {string} key
     * @param {Model}  value
     */
    set(key: string, value: ModelUnion): void {
        this.map.set(key, value);
    }

    /**
     * Retrieve value at key
     * @param {string} key
     *
     * @return {Model}
     */
    get<T = ModelUnion>(key: string): T {
        return this.map.get(key) as T;
    }

    /**
     * Check if has key
     * @param {string} key
     *
     * @return {boolean}
     */
    has(key: string): boolean {
        return this.map.has(key);
    }
}
